import api from './http'
import base from '../assets/js/base'

export default {
    base: base
    ,apiGet: function(url, params, config) {
        if(!params) params = {};
        if(!config) config = {};
        if(base.$ls('wechat_info')) params.openid = base.$ls('wechat_info')['openid'];
        params = base.removeObjNullValue(params);

        return new Promise(function (resolve, reject) {
            api.get(url, {params}).then(function (res, response) {
                switch (res.code) {
                    case 0:
                        resolve(res, response);
                        break;
                    case 403:
                        location.href = 'http://' + document.domain + '/api/wechat/info?back_url=' + location.href;
                        break;
                    default:
                        base.$toast(res.msg ? res.msg : '请求失败');
                        reject(res, response);
                }
            }).catch(function (res, err) {
                base.$toast(res.msg ? res.msg : '请求失败');
                reject(res, err);
            });
        });
    }
    ,apiPost: function(url, data, config) {
        if(!data) data = {};

        if(base.$ls('wechat_info')) data.openid = base.$ls('wechat_info')['openid'];
        data = base.removeObjNullValue(data);

        return new Promise(function (resolve, reject) {
            api.post(url, data, config).then(function (res, response) {
                switch (res.code) {
                    case 0:
                        resolve(res, response);
                        break;
                    case 403:
                        location.href = 'http://' + document.domain + '/api/wechat/info?back_url=' + location.href;
                        break;
                    default:
                        base.$toast(res.msg ? res.msg : '请求失败');
                        reject(res, response);
                }
            }).catch(function (res, err) {
                base.$toast(res.msg ? res.msg : '请求失败');
                reject(res, err);
            });
        });
    }
}
/*

/!**
 * 封装GET请求
 * @param url
 * @param params
 * @param config
 * @returns {Promise<unknown>}
 *!/
export const apiGet = function(url, params, config) {
    if(!params) params = {};
    if(!config) config = {};
    params = base.removeObjNullValue(params);

    return new Promise(function (resolve, reject) {
        api.get(url, {params}).then(function (res, response) {
            switch (res.code) {
                case 0:
                    resolve(res, response);
                    break;
                default:
                    base.$toast(res.msg ? res.msg : '请求失败');
                    reject(res, response);
            }
        }).catch(function (res, err) {
            base.$toast(res.msg ? res.msg : '请求失败');
            reject(res, err);
        });
    });
};

/!**
 * 封装POST请求
 * @param url
 * @param data
 * @param config
 * @returns {Promise<unknown>}
 *!/
export const apiPost = function(url, data, config) {
    if(!data) data = {};
    data = base.removeObjNullValue(data);

    return new Promise(function (resolve, reject) {
        api.post(url, data, config).then(function (res, response) {
            switch (res.code) {
                case 0:
                    resolve(res, response);
                    break;
                default:
                    base.$toast(res.msg ? res.msg : '请求失败');
                    reject(res, response);
            }
        }).catch(function (res, err) {
            base.$toast(res.msg ? res.msg : '请求失败');
            reject(res, err);
        });
    });
};

*/

